import React, { useState, useEffect } from "react";
import AddAccount from "../modals/accounting/AddAccount";
import ChartOfAccountTable from "./ChartOfAccountTable";
import { useDispatch, useSelector } from "react-redux";
import { getAccounts } from "./../../redux/slice/accounting/accountingSlice";
import { BounceLoader } from "react-spinners";
import PageTitle from "../partials/PageTitle";
// import { closeDialog, showDialog } from "../../utils/helpers/toggleTheme";
// import { useRef } from "react";
// import CreateAccount from "./../modals/accounting/CreateAccount";
// import ModalOne from "./../modals/custom/ModalOne";

const ChartOfAccounts = () => {
  const [hasCreateAccounts, setHasCreateAccounts] = useState();
  const { accounts, isSearching, isUpdated, pending } = useSelector(
    (state) => state?.accounting
  );

  const { user_permissions } = useSelector((state) => state?.auth?.user);

  //Used along with ModalOne
  /**start **/
  // const [showModal, setShowModal] = useState(false);

  // const handleClose = (item) => {
  //   setShowModal(false);
  //   closeDialog();
  //   item?.current.reset();
  // };
  /**end **/

  const breadcrumb = {
    from: {
      title: "Accounting",
      link: "/admin/accounting/chart-of-accounts",
    },
    current: {
      title: "Charts of Account",
      link: null,
    },
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState();

  const dispatch = useDispatch();

  const fetchAccounts = async (pageNumber) => {
    setPageNumber(pageNumber);
    dispatch(
      getAccounts({ pageNumber, search: search === undefined ? "" : search })
    );
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (search !== "") {
      dispatch(
        getAccounts({ pageNumber, search: search === undefined ? "" : search })
      );
    }
  };

  useEffect(() => {
    if (isUpdated) {
      fetchAccounts(pageNumber);
    }
  }, [isUpdated]);

  useEffect(() => {
    if (search === undefined || search === "") {
      dispatch(getAccounts({ pageNumber, search: "" }));
    }
  }, [search]);

  useEffect(() => {
    setHasCreateAccounts(
      user_permissions?.some(
        (permission) => permission.name === "create general ledger account"
      )
    );
  }, [user_permissions]);

  return (
    <>
      <PageTitle title='Chart of Accounts' breadcrumb={breadcrumb} />
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='position-relative'>
                {pending && !accounts && (
                  <div
                    className='position-absolute mx-auto w-100 d-flex justify-content-center pt-5 h-100 transparent-primary z-1000 mt-3x'
                    style={{ marginTop: "30px" }}
                  >
                    <div className='text-black fs-4 mx-auto fw-bold '>
                      <BounceLoader
                        color='#090b8f'
                        loading={true}
                        // cssOverride={override}
                        size={50}
                        aria-label='Loading Spinner'
                        data-testid='loader'
                        className='ms-3'
                      />
                      <span className=''>Please wait...</span>
                    </div>
                  </div>
                )}
                <div
                  className={`d-flex ${
                    hasCreateAccounts
                      ? "justify-content-between"
                      : "justify-content-end"
                  }`}
                >
                  {hasCreateAccounts && (
                    <div
                      className='d-flex gap-2 justify-content-center align-items-center rounded-1 btn-primary text-white cursor-p'
                      data-bs-toggle='modal'
                      data-bs-target='#staticBackdrop1'
                      style={{ height: "30px", padding: "10px 10px" }}
                    >
                      <span>
                        <i className='mdi mdi-plus fs-4'></i>
                      </span>
                      <span href='#' className='pe-2 text-white'>
                        Add Account
                      </span>
                    </div>
                  )}
                  <AddAccount modal_id='staticBackdrop1' />
                  <div className='d-flex'>
                    {/* <button className='btn btn-sm btn-secondary text-white me-2'>
                      <i className='mdi mdi-refresh'></i>
                    </button> */}
                    <form
                      className='d-flex bg-primary-1 align-items-center '
                      style={{ height: "30px" }}
                      onSubmit={handleSearch}
                    >
                      <input
                        type='search'
                        className='border-0'
                        placeholder='Search by Account Name ...'
                        onChange={(e) => setSearch(e.target.value)}
                        value={search}
                        style={{
                          height: "28px",
                          marginLeft: "1px",
                          outline: "none",
                        }}
                      />
                      <button
                        type='submit'
                        className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                        style={{ height: "28px" }}
                      >
                        <i className='uil uil-search text-white fs-4'></i>
                      </button>
                    </form>
                  </div>
                </div>
                {/* {pending} */}
                <ChartOfAccountTable
                  accounts={accounts}
                  isLoading={pending}
                  isSearching={search !== undefined}
                  fetchAccounts={fetchAccounts}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChartOfAccounts;
